module.exports = __webpack_public_path__ + "jo.svg?5806167645b758207aeb910e04e25ecf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/jo.svg
// module id = 1434
// module chunks = 0